import React from 'react';
import { format, parseISO } from 'date-fns';

import { FaQrcode } from 'react-icons/fa';
import { IReceita } from '../../hooks/receita';

import {
  Label,
  InstructionBox,
  InstructionHeader,
  InstructionContent,
  InstructionItem,
  InstructionCircle,
  PatientContainer,
  PatientData,
  IssuerContent,
  IssuerTitle,
} from './styles';
import { useClinica } from '../../hooks/clinica';
import { formataCPF, formataIdade } from '../../utils/funcoes';

const formatarData = (data: Date | string, comHora: boolean): string => {
  const formato = comHora ? 'dd/MM/yyyy HH:mm:ss' : 'dd/MM/yyyy';
  try {
    return format(parseISO(data.toString()), formato);
  } catch {
    return '-';
  }
};

interface Props {
  receita: IReceita;
}

const Paciente: React.FC<Props> = ({ receita }) => {
  const { imagensClinica } = useClinica();

  const logo =
    imagensClinica.find(img => img.nome === 'logoRelatorio')?.arquivo_url || '';

  return (
    <>
      {receita.RecControlado && (
        <IssuerContent>
          <IssuerTitle>RECEITUÁRIO CONTROLE ESPECIAL</IssuerTitle>

          <p>1º via - Farmácia * 2º - Paciente</p>

          <div style={{ border: '1px solid #000' }}>
            <p style={{ padding: '10px', borderBottom: '1px solid #000' }}>
              <b>Identificação do Emitente</b>
            </p>
            <img
              src={logo}
              style={{ width: '100%', maxWidth: '200px' }}
              alt="Agenda Facil"
            />
            <p style={{ padding: '10px' }}>
              <b>DOUTOR SP: DRSP 044 SERVICOS MEDICOS LTDA</b>
              <br /> CNPJ 47.896.438/0001-63
              <br />
              PRAÇA PRIMEIRO DE MAIO, 50 , ERMELINO MATARAZZO, SÃO PAULO/SP -
              CEP 03806-080
            </p>
          </div>
        </IssuerContent>
      )}

      <PatientContainer>
        <div style={{ flex: 1 }}>
          {!receita.RecControlado && (
            <img
              src={logo}
              style={{ width: '100%', maxWidth: '200px', marginBottom: '10px' }}
              alt="Agenda Facil"
            />
          )}
          <Label>Paciente:</Label>
          <Label style={{ fontSize: '20px' }}>{receita.RecPacNome}</Label>
          <span>
            {formataIdade(parseISO(receita.RecPacDataNasc.toString()))}
          </span>
          <PatientData>
            <div>
              <Label>CPF do Paciente:</Label>
              <p>{formataCPF(receita.RecPacCPF || '')}</p>
            </div>
            <div>
              <Label>Nascimento:</Label>
              <p>{formatarData(receita.RecPacDataNasc, false)}</p>
            </div>
            <div>
              <Label>Emissão:</Label>
              <p>{formatarData(receita.created_at, true)}</p>
            </div>
          </PatientData>
          <div>
            {receita.RecControlado ? (
              <p>
                <b>Endereço: </b>
                {receita.RecPacEndereco}
              </p>
            ) : (
              <>
                <Label>Endereço:</Label>
                <p>{receita.RecPacEndereco}</p>
              </>
            )}
          </div>
        </div>
        {!receita.RecControlado && (
          <InstructionBox>
            <InstructionHeader>
              <span style={{ fontSize: '1.2rem' }}>
                Acesse sua receita
                <br /> <b>do celular</b>
              </span>
              <div>
                <FaQrcode size={80} />
              </div>
            </InstructionHeader>
            <InstructionContent>
              <InstructionItem>
                <InstructionCircle>1</InstructionCircle>
                Escaneie o QR Code ou acesse: r.drsaopaulo.com.br/MZOZ3CG
              </InstructionItem>
              <InstructionItem>
                <InstructionCircle>2</InstructionCircle>
                Você pode baixar o PDF ou acessar a via digital dos medicamentos
                prescritos sempre que precisar
              </InstructionItem>
              <InstructionItem>
                <InstructionCircle>3</InstructionCircle>
                Seu código de acesso é: 7229
              </InstructionItem>
            </InstructionContent>
          </InstructionBox>
        )}
      </PatientContainer>
    </>
  );
};

export default Paciente;
